'use client';

import { type Context, createContext, type ReactNode, useContext } from 'react';

const PublicAccessContext: Context<boolean> = createContext(false);

/** A server-proven public rollout, not a visitor-controlled access cookie. */
export function CompetitionPublicAccess({
  enabled,
  children,
}: {
  enabled: boolean;
  children: ReactNode;
}): ReactNode {
  return <PublicAccessContext value={enabled}>{children}</PublicAccessContext>;
}

export function useCompetitionPublicAccess(): boolean {
  return useContext(PublicAccessContext);
}
